import { Button, useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import ColorsTable from '../../../components/FuelTypes/FuelTypesTable.js';
import { columnsDataColors } from './variables/columnsDataFuelTypes.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js'; // Asegúrate de importar postData
import { useSearch } from '../../../contexts/SearchContext.js';
import ColorsEditModal from '../../../components/FuelTypes/FuelTypesEditModal.js'; // Asegúrate de importar el modal
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';

export default function Settings() {
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [modalState, setModalState] = useState({ isOpen: false, fuelType: null, isNew: false });
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);


  const loadData = async (dato) => {
    try {
      const params = new URLSearchParams({
        page: String(page + 1),
        limit: String(rowsPerPage),
        data: dato || '',
      });
      appendSortParams(params);
      const response = await getData(`/fuelTypes?${params.toString()}`);
      setData(response?.payload?.fuelTypes || []); // Actualiza los datos
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      console.error('Error fetching fuelTypes:', error);
    }
  };

  useEffect(() => {
    loadData(searchQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openNewFuelTypeModal = () => {
    setModalState({ isOpen: true, fuelType: { id: null, name: '', category: '', currentCost: '', currentStock: '', unit: '' }, isNew: true });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, fuelType: null, isNew: false });
  };

  // Función para crear un nuevo fuelType
  const handleCreateColor = async (newColor) => {
    try {
      await postData('/fuelTypes', newColor); 
      loadData(searchQuery);
    } catch (error) {
      toast({
        title: 'Error al obtener fuelTypes',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Función para actualizar un fuelType
  const handleUpdateColor = async (updatedColor) => {
    try {
      await putData(`/fuelTypes/${updatedColor.id}`, updatedColor); // Actualiza el fuelType en la API
      await loadData(searchQuery); 
      closeEditModal(); 
    } catch (error) {
      toast({
        title: 'Error al actualizar el fuelType',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <AdminPageShell
      title="Tipos de combustible"
      actions={
        <Button variant="adminPrimary" size="sm" onClick={openNewFuelTypeModal}>
          Nuevo tipo
        </Button>
      }
    >
      <ColorsTable
          columnsData={columnsDataColors}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateFuelType={handleUpdateColor}
          sorting={sorting}
          onSortingChange={setSorting}
        />


      <ColorsEditModal
        isOpen={modalState.isOpen}
        onClose={closeEditModal}
        fuelType={modalState.fuelType}
        isNew={modalState.isNew}
        onCreate={handleCreateColor}
        onUpdate={handleUpdateColor}
      />
    </AdminPageShell>
  );
}